import { Page, Text, View, Document, StyleSheet, Image, Font, Note } from '@react-pdf/renderer';


Font.register({
    family: 'Source',
    fonts: [
        { src: require("../../assets/fonts/SourceSansProRegular.ttf") }, // Regular
        { src: require("../../assets/fonts/SourceSansProBold.ttf"), fontWeight: 'bold' }, // Bold
    ],
});




const styles = StyleSheet.create({
    page: {
        paddingTop: 15,
        paddingBottom: 15,
        paddingLeft: 20,
        paddingRight: 20,
        borderWidth: 1,
        borderColor: 'grey',
        fontFamily: 'Source',
    },
    imagesWrapper: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 10,
    },
    wollyLogo: {
        width: 100,
        objectFit: 'cover',
    },
    genericLogo: {
        width: 80,
        objectFit: 'cover',
    },
    titleWrapper: {
        marginTop: 5,
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginBottom: 15,
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
    },
    subtitle: {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#0AAFB4',
    },
    boxesWrapper: {
        flexDirection: 'row',
        width: '100%',
        borderBottomWidth: 1,
        borderColor: '#D1D1D1',
        padding:6
    },
    littleBox: {
       
        padding: 6,
        width: '25%',
        justifyContent: 'center',
    },
    mediumBox: {
       
        padding: 6,
        width: '50%',
        justifyContent: 'center',
    },
    signatureBox: {
        width: '50%',
        justifyContent: 'center',
    },
    fullBox: {
       
        padding: 6,
        width: '100%',
        justifyContent: 'center',
    },
    noteBox: {
       
        padding: 6,
        width: '100%',
        height: 200,
    },
    seventyFiveBox: {
        padding: 6,
        width: '75%',
        justifyContent: 'center',
    },
    boldText: {
        fontWeight: 'bold',
    },

    boxTitleWrapper: {
        marginTop: 10,
        width: '100%',
        backgroundColor: '#F5F6FF',
        justifyContent: 'center',
        alignItems: 'center',
        padding:8
    },
    boxTitle: {
        fontWeight: 'bold',
        padding: 6,
        fontSize: 16,
    },
    signature: {
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 80,
    },
    signatureImage: {
        height: 60,
        objectFit: 'contain',
    },
    evidence: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'center',
        minHeight: 120,
        paddingTop: 10,
        paddingBottom: 10,
    },
    evidenceImage: {
        width: 100,
        height: 'auto',
        marginLeft: 20,
        marginTop: 10,
    },
    regularText: {
        fontSize: 10,
        marginBottom: 2,
    },
    noBorder:{
        borderBottomWidth: 0,
    }
});

// --- Componente principal del documento PDF ---
const GenericPdfStructure = ({ jobData, formatDateWhitoutHour }) => (
    <Document>
        <Page size="LEGAL" style={styles.page}>
            {/* { #header} */}
            <View style={styles.imagesWrapper}>
                <Image style={styles.wollyLogo} src={require("../../assets/wolly-logo-billing.png")} />
                {jobData.business && (
                    <Image style={styles.genericLogo} src={jobData.business} />
                )}
            </View>
            {/* {#ref} */}
            <View style={styles.boxesWrapper}>
                <View style={styles.littleBox}>
                    <Text style={[styles.boldText, styles.regularText]}>ID del Presupuesto</Text>
                </View>
                <View style={styles.littleBox}>
                    <Text style={styles.regularText} >{jobData.ID || ""}</Text>
                </View>
                <View style={styles.littleBox}>
                    <Text style={[styles.boldText, styles.regularText]}>Fecha de emisión</Text>
                </View>
                <View style={[styles.littleBox]}>
                    <Text style={styles.regularText}>{jobData.createdAt ? formatDateWhitoutHour(jobData.createdAt.toString()) : ""}</Text>
                </View>
            </View>
            {/* { #cliente} */}
            <View style={styles.boxTitleWrapper}>
                <Text style={[styles.boxTitle, styles.regularText]}>Datos del cliente</Text>
            </View>
            <View style={styles.boxesWrapper}>
                <View style={styles.littleBox}>
                    <Text style={[styles.boldText, styles.regularText]}>Nombre del cliente</Text>
                </View>
                <View style={styles.littleBox}>
                    <Text style={styles.regularText}>{jobData.clientName || ""}</Text>
                </View>
                <View style={styles.littleBox}>
                    <Text style={[styles.boldText, styles.regularText]}>Teléfono del cliente</Text>
                </View>
                <View style={[styles.littleBox]}>
                    <Text style={styles.regularText}>{jobData.clientPhone || ""}</Text>
                </View>
            </View>
            <View style={styles.boxesWrapper}>
                <View style={styles.littleBox}>
                    <Text style={[styles.boldText, styles.regularText]}>Dirección del servicio</Text>
                </View>
                <View style={[styles.seventyFiveBox]}>
                    <Text style={styles.regularText}>{jobData.jobAddress || ""}</Text>
                </View>
            </View>
            {/* {#servicio} */}
            <View style={styles.boxTitleWrapper}>
                <Text style={[styles.boxTitle, styles.regularText]}>Datos del servicio</Text>
            </View>
            <View style={styles.boxesWrapper}>
                <View style={styles.littleBox}>
                    <Text style={[styles.boldText, styles.regularText]}>Servicio</Text>
                </View>
                <View style={[styles.seventyFiveBox]}>
                    <Text style={styles.regularText}>{jobData.verticalName || ""}</Text>
                </View>
            </View>
            <View style={styles.boxesWrapper}>
                <View style={styles.littleBox}>
                    <Text style={[styles.boldText, styles.regularText]}>Descripción</Text>
                </View>
                <View style={[styles.seventyFiveBox]}>
                    <Text style={styles.regularText}>{jobData.jobDescription || ""}</Text>
                </View>
            </View>

            <View style={styles.boxesWrapper}>
                <View style={[styles.littleBox]}>
                    <Text style={[styles.boldText, styles.regularText]}>El servicio básico incluye:</Text>
                </View>

                <View style={[styles.seventyFiveBox]}>
                    {jobData?.includes?.map((include, key) => (
                        <Text key={key + " includes"} style={styles.regularText}>- {include}</Text>
                    ))}
                    <Text style={styles.regularText}>Para mas informacion relacionada con las inclusiones consulte a Wolly</Text>
                </View>
            </View>

            <View style={styles.boxesWrapper}>
                <View style={[styles.littleBox]}>
                    <Text style={[styles.boldText, styles.regularText]}>El servicio básico NO incluye:</Text>
                </View>
      
                <View style={[styles.seventyFiveBox]}>
                    {jobData?.doesntIncludes?.map((doesntInclude, key) => (
                        <Text key={key + " doesntIncludes"} style={styles.regularText}>- {doesntInclude}</Text>
                    ))}
                    <Text style={styles.regularText}>Para mas informacion relacionada con las exclusiones consulte a Wolly</Text>
                </View>
            </View>

            {/* {#firmas} */}
            <View style={[styles.boxesWrapper ,styles.noBorder]}>
                <View style={[styles.signatureBox, styles.signature]}>
                    {jobData?.signatures?.signature && jobData.signatures.signature !== "" && (
                        <Image style={styles.signatureImage} src={jobData.signatures.signature} />
                    )}
                </View>
                <View style={[styles.signatureBox, styles.signature,]}>
                    {jobData?.signatures?.signaturePro && jobData.signatures.signaturePro !== "" && (
                        <Image style={styles.signatureImage} src={jobData.signatures.signaturePro} />
                    )}
                </View>
            </View>
            <View style={[styles.boxesWrapper ,styles.noBorder]}>
                <View style={[styles.signatureBox,styles.noBorder]}>
                    <Text style={[styles.boldText, styles.regularText]}>Firma del cliente:</Text>
                </View>
                <View style={[styles.signatureBox,styles.noBorder]}>
                    <Text style={[styles.boldText, styles.regularText]}>Firma del profesional:</Text>
                </View>
            </View>
        </Page>
        <Page size="LEGAL" style={styles.page}>

            {/* {#anexos} */}
            <View style={styles.boxTitleWrapper}>
                <Text style={[styles.boxTitle, styles.regularText]}>Documentacion Anexa</Text>
            </View>
            <View style={styles.boxesWrapper}>

                <View style={[styles.fullBox]}>
                    <Text style={[styles.boldText, styles.regularText]}>Fotos del antes (Woller)</Text>
                </View>
            </View>

            <View style={styles.boxesWrapper}>
                <View style={[styles.fullBox, styles.evidence]}>
                    {jobData?.serviceImagesBefore?.map((image, key) =>
                        (<Image key={key + "serviceImagesBefore"} style={styles.evidenceImage} src={image.base64} />)
                    )}
                </View>
            </View>
            <View style={styles.boxesWrapper}>

                <View style={[styles.fullBox]}>
                    <Text style={[styles.boldText, styles.regularText]}>Fotos del despues (Woller)</Text>
                </View>
            </View>

            <View style={styles.boxesWrapper}>
                <View style={[styles.fullBox, styles.evidence]}>
                    {jobData?.serviceImagesAfter?.map((image, key) =>
                        (<Image key={key + "serviceImagesAfter"} style={styles.evidenceImage} src={image.base64} />)
                    )}
                </View>
            </View>
            <View style={styles.boxesWrapper}>

                <View style={[styles.fullBox]}>
                    <Text style={[styles.boldText, styles.regularText]}>Anotaciones</Text>
                </View>
            </View>
            <View style={styles.boxesWrapper}>
                <View style={[styles.noteBox]}>
                    <Text style={styles.regularText}> {jobData?.notes}</Text>
                </View>
            </View>
        </Page>
    </Document>
);

export default GenericPdfStructure;